import React from 'react';
export var BancoAztecaLogo = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "data-testid": "bancoazteca-bank-logo",
    height: "24",
    viewBox: "0 0 84 24",
    width: "84",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("defs", null), React.createElement("title", null, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1"
  }, React.createElement("g", {
    id: "Artboard",
    transform: "translate(-163 -98)"
  }, React.createElement("g", {
    id: "banco-azteca-",
    transform: "translate(163 98)"
  }, React.createElement("g", {
    fillRule: "nonzero",
    id: "outline"
  }, React.createElement("path", {
    d: "M81 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h78c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
    fill: "#000",
    id: "Path",
    opacity: ".07"
  }), React.createElement("path", {
    d: "M83 3v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h78c1.1 0 2 .9 2 2z",
    fill: "#FFF",
    id: "Path"
  })), React.createElement("g", {
    id: "logo",
    transform: "translate(4 7)"
  }, React.createElement("path", {
    d: "M8.3179 3.3405c-1.4983 0-2.7156 1.216-2.7156 2.7164 0 1.501 1.2173 2.7164 2.7156 2.7164 1.5018 0 2.7177-1.2155 2.7177-2.7164 0-1.5005-1.216-2.7164-2.7177-2.7164",
    fill: "#A52D31",
    id: "Fill-23"
  }), React.createElement("path", {
    d: "M9.7316.5946S9.6653.574 9.5495.5422C10.1775.3552 10.9658.1517 11.84 0c-1.2258 0-2.2682.0613-3.1522.1977a14.2824 14.2824 0 00-.369.0631 14.6616 14.6616 0 00-.3696-.063C7.0652.0612 6.0233 0 4.7975 0c.8742.1517 1.6629.3552 2.2906.5418-.1164.0322-.183.0528-.183.0528C2.8479 1.8656-.2085 4.644.011 6.922.1932 8.8127 2.1205 9.7714 5.2623 9.444c-1.747-.3162-2.4632-1.1998-2.5925-2.5388-.1981-2.0498 2.126-4.4732 5.4253-5.8672 0 0 .081-.0331.2241-.0868.1427.0537.2241.0868.2241.0868 3.299 1.394 5.6217 3.8174 5.4248 5.8672-.1284 1.339-.846 2.2226-2.593 2.5388 3.1415.3275 5.0706-.6312 5.2517-2.5218.2197-2.278-2.8372-5.0566-6.8952-6.3275",
    fill: "#1B5C3C",
    id: "Fill-24"
  })), React.createElement("g", {
    fill: "#636669",
    id: "name",
    transform: "translate(23 9)"
  }, React.createElement("path", {
    d: "M3.9994 2.8853v-.0176c.9364-.1107 1.557-.7071 1.557-1.5061C5.5564.239 4.4924.0013 3.8803.0013H1.2424L0 5.9393l2.7062-.0333c1.361-.0162 2.4419-.6133 2.4419-1.872 0-.6551-.4675-1.0471-1.1487-1.1487M2.2296 4.816h-.4259l.2898-1.3948h.3829c.7143 0 1.0894.0775 1.0894.5958 0 .5776-.5372.799-1.3362.799m.689-2.4673h-.5953l.2553-1.2248h.409c.5951 0 .9864.0762.9864.5535 0 .4083-.3913.6713-1.0555.6713",
    id: "Fill-25"
  }), React.createElement("path", {
    d: "M8.2789 1.404c-.6896 0-1.174.1015-1.6253.2552l-.153 1.1154c.5105-.2644.8862-.3497 1.4377-.3497.5027 0 .8172.2572.8172.5711 0 .06 0 .1185-.0169.1784-.213-.0182-.519-.0423-.825-.0423-1.3531 0-2.4438.5352-2.4438 1.6253 0 .8589.5287 1.2847 1.4814 1.2847.5958 0 1.1662-.2122 1.4898-.7234v-.017l.017.017-.0678.6219h1.2503c.17-1.3369.562-2.3325.562-3.0299 0-1.0881-.8687-1.5068-1.9236-1.5068m-.842 3.6172c-.3236 0-.5196-.2396-.5196-.4428 0-.39.536-.6537 1.2678-.6296.0938 0 .2813 0 .4083.0253-.11.5965-.5014 1.0471-1.1565 1.0471",
    id: "Fill-26"
  }), React.createElement("path", {
    d: "M14.2865 1.404c-.8094 0-1.2685.332-1.7106.8256h-.017l.1199-.7228h-1.4215c-.043.3998-.1107.7749-.1875 1.1578l-.689 3.276h1.531l.4342-2.0427c.1107-.6551.4936-1.217 1.1402-1.217.4259-.0163.5952.2467.5952.5098 0 .2305-.0593.4513-.1016.6726l-.4252 2.0773h1.5817l.409-2.0681c.0937-.4682.1197-.6382.1197-.9358 0-.8686-.485-1.5328-1.3785-1.5328",
    id: "Fill-27"
  }), React.createElement("path", {
    d: "M18.9918 2.5272c.3393 0 .6714.0937.9865.239l.3321-1.0634c-.4512-.1882-1.0217-.2976-1.3954-.2976-1.7015 0-2.86 1.1558-2.86 2.6118 0 1.1142.8003 2.0251 2.0936 2.0251.5958 0 1.0047-.0683 1.3107-.1706l.2214-1.148c-.332.1361-.6042.1954-.9865.1954-.6479 0-1.0562-.433-1.0562-.9611 0-.9195.5613-1.4306 1.3538-1.4306",
    id: "Fill-28"
  }), React.createElement("path", {
    d: "M22.9567 1.404c-1.7366 0-2.8599 1.0554-2.8599 2.613 0 1.1142.6642 2.0251 2.3071 2.0251 1.6585 0 2.8586-.8087 2.8586-2.6554 0-1.1141-.8003-1.9828-2.3058-1.9828m-.4421 3.5658c-.5196.009-.8341-.3914-.8341-.9865 0-.7072.459-1.5062 1.1994-1.5062.5952 0 .7996.4337.7996.8915 0 1.0054-.4506 1.6012-1.1649 1.6012",
    id: "Fill-29"
  }), React.createElement("path", {
    d: "M30.2224 0l-3.5312 5.9406h1.7197l.7052-1.2692h2.3064l.1615 1.2692h1.6L32.2136 0h-1.9913zm-.4844 3.5482l1.2587-2.3227h.0175l.2553 2.3227H29.738z",
    id: "Fill-30"
  }), React.createElement("path", {
    d: "M34.0682 2.63h1.8975l-2.4165 2.1515-.2214 1.1591h3.8549l.2305-1.1246h-2.0251l2.4334-2.1514.237-1.1578h-3.7598L34.0682 2.63",
    id: "Fill-31"
  }), React.createElement("path", {
    d: "M40.4333 2.5793h1.1148l.1869-1.0725h-1.0556l.3067-1.3876-1.6168.435-.213.9526H38.28l-.1875 1.0725h.8178l-.2643 1.2424c-.1023.4682-.1368.6889-.1368.9103 0 .9273.6225 1.3101 1.4052 1.3101.306 0 .6284-.0345.9527-.0853l.1706-1.0119c-.1622.0593-.3321.127-.4949.127-.3054 0-.5007-.196-.5007-.4936 0-.2136.0586-.435.1263-.767l.265-1.232",
    id: "Fill-32"
  }), React.createElement("path", {
    d: "M44.2367 1.4052c-1.975 0-2.6554 1.5817-2.6554 2.6118 0 1.1142.8003 2.0251 2.2797 2.0251.4428 0 1.0126-.0853 1.5498-.2468l.1953-1.0809c-.4258.2045-.9787.3067-1.387.3067-.9363 0-1.174-.3738-1.1916-.851h3.14c.0598-.2631.1106-.6551.1106-.8342 0-1.3446-.8758-1.9307-2.0414-1.9307m-1.1154 1.8975c.1107-.4259.4682-.8778 1.1324-.8778.5613 0 .7482.4005.7482.8778h-1.8806",
    id: "Fill-33"
  }), React.createElement("path", {
    d: "M49.5887 2.5272c.3399 0 .6713.0937.9871.239l.3315-1.0634c-.4513-.1882-1.0217-.2976-1.3955-.2976-1.7021 0-2.8599 1.1558-2.8599 2.6118 0 1.1142.8003 2.0251 2.0935 2.0251.5958 0 1.0047-.0683 1.3101-.1706l.222-1.148c-.332.1361-.6048.1954-.987.1954-.6473 0-1.0563-.433-1.0563-.9611 0-.9195.562-1.4306 1.3545-1.4306",
    id: "Fill-34"
  }), React.createElement("path", {
    d: "M53.4507 1.404c-.6896 0-1.174.1015-1.6253.2552l-.1537 1.1154c.5112-.2644.8863-.3497 1.4384-.3497.5027 0 .8166.2572.8166.5711 0 .06 0 .1185-.0156.1784-.2136-.0182-.5197-.0423-.8257-.0423-1.3531 0-2.4438.5352-2.4438 1.6253 0 .8589.5294 1.2847 1.482 1.2847.5958 0 1.1656-.2122 1.4892-.7234v-.017l.0163.017-.0677.6219h1.2509c.17-1.3369.5626-2.3325.5626-3.0299 0-1.0881-.8687-1.5068-1.9242-1.5068m-.842 3.6172c-.3236 0-.5196-.2396-.5196-.4428 0-.39.5366-.6537 1.2678-.6296.0938 0 .2807 0 .4083.0253-.11.5965-.5014 1.0471-1.1565 1.0471",
    id: "Fill-35"
  }))))));
};
BancoAztecaLogo.defaultProps = {
  title: 'Banco Azteca'
};